export class Recaptcha {

    constructor ( target = '.js-recaptcha', options = {} ) {

        this.target = target;

        this.options = {
            ...options
        }
    }

    init () {
        this.$recaptchas = document.querySelectorAll( this.target );

        if ( !this.$recaptchas ) {
            return;
        }

        const src = 'https://www.google.com/recaptcha/api.js?render=' + this.$recaptchas[ 0 ].dataset.sitekey;
        const recaptchaSDK = document.createElement( 'script' );
        recaptchaSDK.onload = () => {
            this.loadCaptchas()
        };
        recaptchaSDK.src = src;

        document.head.appendChild( recaptchaSDK );

    }

    loadCaptchas () {
        this.$recaptchas.forEach( ( $recaptcha ) => {
            const options = {
                ...this.options,
                sitekey: $recaptcha.dataset.sitekey,
                action: $recaptcha.dataset.action ?? 'submit'
            };

            let $form = $recaptcha.parentNode;

            while ( $form.tagName !== 'FORM' ) {
                $form = $form.parentNode;
            }

            if ( !$form ) {
                return;
            }

            $form.addEventListener( 'submit', ( event ) => {
                event.preventDefault();
                this.execute( event, $form, options )
            } );

        } );
    }

    execute ( event, $form, options ) {
        grecaptcha.ready( () => {
            grecaptcha.execute( options.sitekey, { action: options.action } ).then( ( token ) => {
                $form.querySelector( '#g-recaptcha-response' ).value = token;
                $form.captchaChecked = true;
                $form.submit();
            } );
        } );
    }

}
